import React, { FC } from "react";
import { Text } from "@postenbring/hedwig-react";
import { LoginCard } from "./LoginCard";
import styles from "./Login.module.css";
import BankId from "../../assets/bankid.svg?react";
import Buypass from "../../assets/buypass.svg?react";
import Translated from "../infrastructure/translation/Translated";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { Navigate } from "react-router";
import { useRootPath } from "../infrastructure/translation/useRootPath";

const Login: FC = (): React.ReactElement => {
  const rootPath = useRootPath();
  const entrypoint = useEntrypointContext();

  if (entrypoint.rolle === "VIRKSOMHET") {
    return <Navigate to={rootPath} />;
  }

  return (
    <main>
      <div className={styles.column}>
        <Text variant="h1" as="h1" size="min" className={styles.title}>
          <Translated textKey={"login.header"} />
        </Text>

        <ul className={styles.methods}>
          <LoginCard
            title={"login.bankid_title"}
            description={"login.bankid_desc"}
            logo={<BankId />}
            loginMethod="nbid"
          />
          <LoginCard
            title={"login.buypass_title"}
            description={"login.buypass_desc"}
            logo={<Buypass />}
            loginMethod="buypass"
          />
        </ul>
      </div>
    </main>
  );
};

export default Login;
